export default {
    //host: process.env.VUE_APP_API_HOST,
    //userApiHost: process.env.VUE_APP_USER_API_HOST,
    url: process.env.VUE_APP_API_URL,
    version: process.env.VUE_APP_API_VERSION,
    env: process.env.VUE_APP_API_ENV,
    //type: process.env.VUE_APP_API_TYPE,
};
